import React from "react";
import { Table } from "antd";
import accounting from "accounting";
import moment from "moment";
import "moment/locale/ru";

const MaterialOrder = ({ material_order, ...rest }) => {
  const columns = [
    {
      title: "Код",
      dataIndex: "order_item_id",
      width: "10%"
    },
    {
      title: "Продукция",
      dataIndex: "product_name",
      width: "30%"
    },
    {
      title: "Материал",
      dataIndex: "material_name",
      width: "30%"
    },
    {
      title: "Кол-во",
      dataIndex: "quantity",
      align: "right",
      width: "15%"
    },
    {
      title: "Сумма",
      dataIndex: "amount",
      render: (amount, record) => (accounting.formatNumber(amount, 0, " ")),
      align: "right",
      width: "15%"
    }
  ];
  const data = material_order ? material_order.material_order_items : []

  return  (
    <Table
      style={{background: "white"}}
      columns={columns}
      dataSource={data}
      size="small"
      title={() => `Списание материалов #${material_order.number} от ${moment(material_order.date).format('LLL')}`}
      pagination={false}
      rowKey="id"
    />
  );
};

export default MaterialOrder;
